<template>
  <div>
    <b-container class="fp-container bg-light-grey" fluid>
      <b-container class="my-5">
        <b-row>
          <b-col md="4" class="mb-4">
            <router-link to="/" class="button-orange">
              <font-awesome-icon icon="arrow-circle-left" class="icon"></font-awesome-icon> Palaa edelliseen
            </router-link>
          </b-col>
          <b-col md="6">
            <h1>Aloita hankkeeseen ryhtyminen</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" offset-md="4">
            <span class="mr-2">Valitse käyttötarkoitus:</span>
            <el-select v-model="userSelection.kayttotarkoitus" placeholder="Valitse" @change="fetchReferences">
              <el-option
                v-for="item in kayttotarkoitukset"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
          </b-col>
          <b-col md="6" class="text-left">
          </b-col>
        </b-row>

        <b-row class="pt-5" v-if="referenssit.length > 0">
          <b-col md="9" offset-md="4">
            <b-card title="Referenssejä">
              <b-row class="pt-3">
                <b-col md="4" v-for="(item,index) in referenssit" :key="index" class="text-left pb-3">
                  <a :href="item.acf.referenssi_linkki" target="_blank" class="">
                    {{item.title.rendered}}
                  </a>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="pt-5" v-if="userSelection.kayttotarkoitus != null">
          <b-col md="6" offset-md="4">
            <router-link to="/puunkaytonmahdollisuus" class="button-orange">
              <font-awesome-icon icon="arrow-circle-right" class="icon"></font-awesome-icon> Seuraava
            </router-link>
          </b-col>
        </b-row>
      </b-container>
    </b-container>

    <b-container>
      <b-row class="py-5">
        <b-col md="3" class="text-left">
          <a name="ohje"></a>
          <p v-for="(item,index) in contentNodes" :title="item.title" :key="index" class="m-0 mb-3">
            <a href="#ohje" @click="showContent(item, $event)"
               :class="item.title==selectedTitle?'itemlink itemlink-active':'itemlink'">{{item.title }}</a>
          </p>
        </b-col>
        <b-col md="8" offset-md="1" class="content-node">
          <h2 class="text-left mb-3">{{selectedTitle}}</h2>
          <div v-html="selectedContent"></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable */
  import kayttotarkoitukset from '../data/kayttotarkoitukset.js'

  export default {
    name: 'Ryhtyminen',
    data() {
      return {
        kayttotarkoitukset: kayttotarkoitukset,
        contentNodes: [],
        selectedTitle: '',
        selectedContent: '',
        referenssit: [],
      }
    },
    created: function () {
      this.fetchPage('hankkeeseen-ryhtyminen', data => {
        if (data.length > 0) {
          this.filterContent(data[0].content.rendered, this.contentNodes)
          this.showContent(this.contentNodes[0])
        }
      })
      this.fetchReferences()
    },
    methods: {
      filterContent(htmlString, contentNodes) {
        var virtual = new DOMParser().parseFromString(htmlString, 'text/html')
        var nodes = virtual.firstChild.childNodes[1].childNodes
        var contentTitle = ''
        var contentHtml = ''
        nodes.forEach(node => {
          if (node.nodeName === 'H2') {
            if (contentTitle !== '') {
              contentHtml += '<div class="clearfix"></div>'
              contentNodes.push({title: contentTitle, content: contentHtml})
            }
            contentTitle = node.innerText
            contentHtml = ''
          } else if (node.outerHTML) {
            contentHtml += node.outerHTML
          }
        })
        contentNodes.push({title: contentTitle, content: contentHtml})
      },
      fetchPage(slug, callback) {
        const params = {
          'filter[name]': slug,
          rest_route: '/wp/v2/pages'
        }
        this.axios
          .get('https://epuu.fi/', {params})
          .then(response => {
            callback(response.data)
          })
          .catch(error => {
            console.error(error)
          })
      },
      showContent(item, e) {
        this.selectedTitle = item.title
        this.selectedContent = item.content
        if (e) {
          // e.preventDefault()
        }
      },
      fetchReferences(option) {
        if( option >= 0 ){
          this.userSelection.kt = kayttotarkoitukset[option].group
          this.userSelection.ktid = option

          var cat = this.kayttotarkoitukset[userSelection.kayttotarkoitus].category
          // console.debug(cat)
          
          const params = {
            'filter[posts_per_page]': 100,
            'filter[category_name]': cat,
            rest_route: '/wp/v2/posts'
          }
          this.axios
            .get('https://epuu.fi/', {params})
            .then(response => {
              this.referenssit = response.data
            })
            .catch(error => {
              console.error(error)
            })
        }
      }
    }
   }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Ryhtyminen.vue